//cardapio-online\libs\core\shell\src\lib\layout\admin\shell-admin-sidebar\shell-admin-sidebar.component.ts
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { AdminNavItem } from '../../../models/admin-nav-item.model';
import { ONBOARDING_RESTART_EVENT } from '@cardapio-online/onboarding'
import { APP_CONFIG, AppConfig } from '@cardapio-online/config';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: 'lib-shell-admin-sidebar',
  templateUrl: './shell-admin-sidebar.component.html',
  styleUrl: './shell-admin-sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellAdminSidebarComponent {
  @Input({ required: true }) navItems: AdminNavItem[] = [];
  @Input() brandTitle = 'Produto Hub';
  @Input() brandSubtitle = 'Painel administrativo';
  @Input() brandLogo = 'Painel administrativo';
  @Input() isMobileOpen = false;
  @Input() isMenuEditing = false;
  @Input() menuEditingEnabled = true;

  @Output() sidebarNavigate = new EventEmitter<void>();
  @Output() navItemsReordered = new EventEmitter<AdminNavItem[]>();
  @Output() menuEditStart = new EventEmitter<void>();
  @Output() menuEditCancel = new EventEmitter<void>();
  @Output() menuEditSave = new EventEmitter<void>();

  constructor(@Inject(APP_CONFIG) public readonly cfg: AppConfig) {}

  protected restartTutorial(): void {
    window.dispatchEvent(new CustomEvent(ONBOARDING_RESTART_EVENT));
  }

  protected handleNavigate(): void {
    this.sidebarNavigate.emit();
  }

  protected startMenuEditing(): void {
    this.menuEditStart.emit();
  }

  protected cancelMenuEditing(): void {
    this.menuEditCancel.emit();
  }

  protected saveMenuEditing(): void {
    this.menuEditSave.emit();
  }

  protected onDrop(event: CdkDragDrop<AdminNavItem[]>): void {
    if (!this.isMenuEditing || event.previousIndex === event.currentIndex) {
      return;
    }

    const nextItems = [...this.navItems];
    moveItemInArray(nextItems, event.previousIndex, event.currentIndex);

    this.navItemsReordered.emit(
      nextItems.map((item, index) => ({
        ...item,
        order: index + 1,
      }))
    );
  }

  protected trackByRoute(index: number, item: AdminNavItem): string {
    return item.route;
  }
}
